<template>
  <button class="close icon icon-dc_phone_icon_all_close" @click="click">
  </button>
</template>

<script>
export default {
  methods: {
    click () { this.$emit('click') }
  }
}
</script>

<style lang="postcss" scoped>
@import "index.css";
.close {
  width:26px;
  height:26px;
  background:rgba(255,255,255,0.2);
  border-radius: 100px;
  outline: none;
  border: 0;
  padding: 0;
  cursor: pointer;

  color: var(--colorGray3);
  @media (--mediaPc) {
    font-size: var(--textSize6);
  }
  @media (--mediaMobile) {
    font-size: var(--textSize6Mobile);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Close.vue